import { createContext, useContext } from "react";
import { GtmDataLayerEvent } from "@made-people/grease-gtm";
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";

export const mmGtmContext = createContext<
  | {
      pusher: (data: GtmDataLayerEvent) => void;
      frontendContext: FrontendContextV1;
    }
  | undefined
>(undefined);

export const useMmGtm = () => {
  const context = useContext(mmGtmContext);
  if (!context) {
    throw new Error("useMmGtm must be used within a MmGtmProvider.");
  }
  return context;
};
